import { IconButton, Menu, MenuItem } from '@mui/material';
// import NotificationsIcon from '@mui/icons-material/Notifications';
import LogoutIcon from '@mui/icons-material/Logout';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';

import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { removeLoginEncryptedLocalStorage } from '../utils/localStorage';
import { DrawerComponent } from './DrawerComponent';
import Sidebar from 'react-sidebar';
import MenuIcon from '@mui/icons-material/Menu';
import { HelmetComponent } from './HelmetComponent';

import logoDark from './../assets/images/logo-dark.png';
import logoLight from './../assets/images/logo-light.png';

const mql = window.matchMedia(`(min-width: 800px)`);


export const NavbarComponents = (props) => {
    const systemMode = props?.currentTheme?.palette?.mode === 'dark' ? true : false;

    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const navigate = useNavigate();
    const location = useLocation();

    // You can now access various properties of the location object
    const { pathname } = location;

    const handleLogout = (event) => {
        event.preventDefault();
        removeLoginEncryptedLocalStorage();
        navigate('/login');
    };



    const [leftSidebarDocked, setLeftSidebarDocked] = useState(mql.matches);
    const [leftSidebarOpen, setLeftSidebarOpen] = useState(false);

    const mediaQueryChanged = () => {
        setLeftSidebarDocked(mql.matches);
        setLeftSidebarOpen(false);
    };

    useEffect(() => {
        mql.addListener(mediaQueryChanged);
        return () => {
            mql.removeListener(mediaQueryChanged);
        };
    }, []);

    const onSetLeftSidebarOpen = () => {
        if (mql.matches)
            setLeftSidebarDocked(!leftSidebarDocked);
        else
            setLeftSidebarOpen(!leftSidebarOpen);
    };

    useEffect(() => {
        if (pathname === '/creator-hmi') {
            if (mql.matches)
                setLeftSidebarDocked(false);
            else
                setLeftSidebarOpen(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname])

    return <>
        <HelmetComponent title={props?.title} />
        <Sidebar

            sidebarClassName={systemMode ? `bg-black` : ''}
            sidebar={
                <>
                    <DrawerComponent systemMode={systemMode} pathname={pathname} />
                </>
            }
            open={leftSidebarOpen}
            docked={leftSidebarDocked}
            onSetOpen={onSetLeftSidebarOpen}
        >
            {!["/login"].includes(pathname) && (
                <>
                    <nav className={`navbar navbar-expand navbar-light py-0 z-3 ${systemMode ? 'shadow-sm-dark bg-dark-mode' : 'shadow-sm bg-white'} fixed-top user-select-none rounded-bottom-4 `}>
                        <div className="container-fluid">

                            <div className='d-flex'>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="start"
                                    onClick={onSetLeftSidebarOpen}
                                >
                                    <MenuIcon />
                                </IconButton>
                                <Link to="/" className="navbar-brand align-middle" >

                                    {/* <img src='https://agua.one/AIO/assets/images/agua_logo.png' alt="Nara" height="50" className='bg-white rounded' loading='lazy' /> */}
                                    <img src={systemMode ? logoDark : logoLight} alt="Agua" height="30" loading='lazy' />
                                    <span className={`text-center fs-6 ${systemMode ? 'text-white' : 'text-black'}`}> AIO</span>
                                </Link>
                            </div>

                            <div className="navbar-nav ml-auto align-items-center ">
                                <Link className="nav-link d-none d-md-block" onClick={() => props.toggleTheme()}>
                                    <IconButton aria-label="mode" title={`${!systemMode ? 'Dark' : 'Light'} Mode`}>
                                        {!systemMode && <DarkModeIcon />}
                                        {systemMode && <LightModeIcon />}
                                    </IconButton>
                                </Link>

                                <Link className="nav-link d-none d-md-block" >
                                    <IconButton aria-label="logout" title='Logout' onClick={handleLogout}>
                                        <LogoutIcon />
                                    </IconButton>
                                </Link>

                                <Link className="nav-link d-block d-md-none" onClick={handleMenu}>
                                    <IconButton
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                    >
                                        <MoreVertIcon />
                                    </IconButton>
                                </Link>

                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorEl}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                >
                                    <MenuItem onClick={() => props.toggleTheme()}>
                                        <Link className="nav-link" >
                                            {!systemMode && <><DarkModeIcon />  DarkMode</>}
                                            {systemMode && <><LightModeIcon /> Light Mode</>}
                                        </Link>
                                    </MenuItem>
                                    <MenuItem onClick={(event) => { handleClose(); handleLogout(event) }}>
                                        <Link className="nav-link">
                                            <LogoutIcon /> Logout
                                        </Link>
                                    </MenuItem>
                                </Menu>
                            </div>
                        </div>
                    </nav>
                    <div className='container-fluid mt-5 pt-5'>
                        {props?.component}
                    </div>
                </>
            )}
        </Sidebar>


    </>;
}